import { isUnavailableSlot } from 'containers/AwarenessCenter/WizardCampaign/WizardTrainingCampaign/playlist'

export const MISSING_DURATION_LABEL = '–'

export const pickItem = (video, defaultLocaleId) => {
  const items = video?.items || []
  return items.find(({ localeId }) => localeId === defaultLocaleId) || items[0]
}

export const getVideoDurationSeconds = (video, defaultLocaleId) =>
  Number(pickItem(video, defaultLocaleId)?.duration) || null

// Null when no live video is left or one has no duration, so a partial sum is never shown as the total.
export const getPlaylistDurationSeconds = (videos, defaultLocaleId) => {
  const durations = videos
    .filter((video) => !isUnavailableSlot(video))
    .map((video) => getVideoDurationSeconds(video, defaultLocaleId))

  return !durations.length || durations.includes(null)
    ? null
    : durations.reduce((sum, seconds) => sum + seconds, 0)
}

export const getVideoThumbnail = (video, defaultLocaleId) =>
  pickItem(video, defaultLocaleId)?.imagePreview || ''

export const formatDurationClock = (totalSeconds) => {
  const seconds = Math.max(0, Math.floor(totalSeconds || 0))
  const hours = Math.floor(seconds / 3600)
  const minutes = Math.floor((seconds % 3600) / 60)
  const pad = (n) => String(n).padStart(2, '0')

  return hours > 0
    ? `${hours}:${pad(minutes)}:${pad(seconds % 60)}`
    : `${minutes}:${pad(seconds % 60)}`
}

export const formatTotalMinutesLabel = (totalSeconds) =>
  totalSeconds === null
    ? MISSING_DURATION_LABEL
    : `${Math.max(0, Math.round((totalSeconds || 0) / 60))}m`
